import { render, staticRenderFns } from "./PayerCof.vue?vue&type=template&id=596d41d2&scoped=true&"
import script from "./PayerCof.vue?vue&type=script&lang=js&"
export * from "./PayerCof.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=596d41d2&lang=less&scoped=true&"
import style1 from "./PayerCof.vue?vue&type=style&index=1&id=596d41d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d41d2",
  null
  
)

export default component.exports